<template>
<div>
	<!-- <van-popup v-model="passShowFlag" closeable>
    		<div class="popup">
        		<div class="popup_title">
					请输入访问密码
            	</div>
				<van-field v-model="password" type="password" placeholder="密码" />
				<div class="buttonGroup">
				<van-button type="primary" @click="meetingPassword" class="button">确认</van-button>
				</div>
			</div>
	</van-popup> -->
	<div class="item-block" @click="goDetails()">
		<div class="cover">
			<img :src="itemContent.banner" alt="">
		</div>
		<div class="details">
			<p class="line-clamp-2" style="line-height:0.46rem">{{itemContent.name}}</p>
			<div class="hasWriter " v-if="(routerName=='InstrumentDetails'||routerName=='Guide'||routerName=='RegionIndex')&&itemContent.writers&&itemContent.writers.length>0">
				<div class="guide-name" v-if="(routerName=='InstrumentDetails'||routerName=='Guide'||routerName=='RegionIndex')&&itemContent.writers&&itemContent.writers.length>0" >{{itemContent.writers[0].name}}</div>
				<div class="guide-name line-clamp-1" v-if="(routerName=='InstrumentDetails'||routerName=='Guide'||routerName=='RegionIndex')&&itemContent.writers&&itemContent.writers.length>0">{{itemContent.writers[0].company}}</div>
			</div>
			<div class="bottom" v-else>
				<!-- 器械百科 -->
				
				<!-- 会议详情页时展示 start-->
				<!-- <div class="left line-clamp-1" v-if="routerName=='MeetingIndex'||routerName=='MeetingSearch'||searchType==0||routerName=='MeetingCalendar'">{{itemContent.province.name}} {{itemContent.city.name}}</div> -->
				<div class="right" v-if="routerName=='MeetingIndex'||routerName=='MeetingSearch'||routerName=='ExpertDetails'||searchType==0||routerName=='MeetingCalendar'"><van-icon name="clock-o" />{{itemContent.start_at+'-'+itemContent.end_at}}</div>

				<div class="left line-clamp-1" v-if="routerName=='ColumnDetails'||routerName=='CaseList'">
					{{itemContent.readnum}} 阅读
				</div>
				<!-- 首页 专访列表   首页搜索   病例首页-->
				<div class="left" v-if="searchType==3||routerName=='CaseIndex'||routerName=='Index'||routerName=='ExclusiveViewList'||routerName=='VowIndex'" style="width:100%">
					{{itemContent.created_at}}
				</div>
				<!-- 资讯详情时显示 -->
				<div class="left" v-if="routerName=='InformationDetails'" style="width:150px">
					{{itemContent.readnum}} 阅读  <span style="margin-left: 10px"></span>{{itemContent.follows}} 收藏
				</div>
				<!-- 个人收藏时显示 -->
				<div v-if="routerName=='PersonalCollect' "	 class="left">
					{{itemContent.follow_users_count}} 收藏
					
				</div>
				<!-- 专栏搜索 -->
				<div class="left" v-if="routerName=='ColumnSearch'||searchType==1" style="width:150px">
					{{itemContent.follows}} 关注  
				</div>	
				<!-- 医院专栏详情			 -->
				<div class="left" v-if="routerName=='ColumnHospital'||routerName=='HospitalSearch'||routerName=='RegionIndex'" :style="{'width':routerName=='RegionIndex'?'100%':''}">{{itemContent.release_at}}</div>
				<div class="right" v-if="routerName=='ColumnHospital'||routerName=='HospitalSearch'">
					<van-icon name="star" @click.stop="collectArticle" v-if="itemContent.isCollect=='1'"/>
					<van-icon name="star-o" v-if="itemContent.isCollect=='0'" @click.stop="collectArticle" />
				</div>	
			</div>
		</div>
	</div>
</div>
</template>
<script>
	import {ArticlesAddRead,ArticlesCollect,MeetingPermission} from "../config/interface.js"
	export default{
	    props:{
	    	  itemContent:Object,
	    	  name:String,
	    	  length:Number,
	    	  searchType:Number,   //搜索类型 （用于搜索列表页  0:会议;1：专栏;2:器械,3:文章）
	  	},
		mounted(){

		},
		data(){
			return{
				routerName:'',     //路由名称    
				// passShowFlag:false,
				// password:''
			}
		},
		mounted(){
			
			this.routerName=this.$route.name;
			console.log(this.routerName)
		},
		methods:{
			//跳转详情页
			goDetails(){
				switch(this.routerName){
					case 'ColumnDetails':
					//专栏详情
					// this.skipArticleDetails();
					this.AddArticleRead();
					break;
					case 'VowIndex':
					//VOW首页
					this.skipArticleDetails();
					break;
					case 'MeetingIndex':
					//会议首页
					this.skipMeetingDetails();
					break;
					case 'MeetingSearch':
					//会议搜索
					this.skipMeetingDetails();
					break;
					case 'MeetingCalendar':
					//会议日程
					this.skipMeetingDetails();
					break;
					case 'ExpertDetails':
					//专家详情
					this.skipMeetingDetails();
					break;
					case 'CaseList':
					//病例列表
					this.AddArticleRead();
					break;
					case 'InformationDetails':
					//资讯详情
					this.AddArticleRead();
					break;
					case 'ColumnSearch':
					//专栏搜索
					this.$router.push({
						path:'/column/details',
						query:{
							id:this.itemContent.id
						}
					})
					break;	
					case 'InstrumentDetails':
						//器械百科详情
						this.skipArticleDetails();
					break;	
					case 'Guide':
						//指南/共识
						this.skipArticleDetails();
					break;		
					case 'cecInfo':
						this.skipArticleDetails();
						break;		
					case 'PersonalCollect':
					//我的收藏
					this.skipArticleDetails();
					break;
					case 'ExclusiveViewList':
					this.AddArticleRead();

					//专访列表
					break;
					case 'Index':
					if(this.itemContent.resource_type==0){
						this.AddArticleRead();
					}else if(this.itemContent.resource_type==1){
						this.AddArticleRead();
					}else if(this.itemContent.resource_type==2){
						this.skipMeetingDetails();
					}else{

					}
					break;
					case 'ColumnHospital':
					this.skipArticleDetails();
					break;
					case 'HospitalSearch':
					this.skipArticleDetails();
					break;
					case 'RegionIndex':
					this.skipArticleDetails();
					break;
				}
				switch(this.searchType){
					case 0:
					//跳转会议详情
					this.skipMeetingDetails();
					break;
					case 1:
					//跳转专栏详情
					this.$router.push({
						path:'/column/details',
						query:{
							id:this.itemContent.id
						}
					});
					break;
					case 3:
					//跳转文章
						this.AddArticleRead();
					break;

				}
			},
			//文章详情页面
			skipArticleDetails(){
				if(this.itemContent.bind_url&&this.itemContent.type==3){
					this.$router.push({
						path:'/video',
						query:{
							id:this.itemContent.id
						}
					})
				}
				else{
					if(this.itemContent.bind_url){
						window.location.href=this.itemContent.bind_url;
					}else{
						this.$router.push({
								path:'/exclusiveView/details',
								query:{
									article_id:this.itemContent.pivot?this.itemContent.pivot.article_id:this.itemContent.id,
									column_id:this.itemContent.pivot?this.itemContent.pivot.column_id:0
								}
						})
					}
				}

			},
			//增加文章阅读量
			AddArticleRead(){
				const url=ArticlesAddRead;
				const method='POST';
				let params={
					article_id:this.itemContent.pivot?this.itemContent.pivot.article_id:this.itemContent.id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.skipArticleDetails()
					}
				})
			},
			//跳转到会议详情 需要判断该会是否要密码
			skipMeetingDetails(){
				const url=MeetingPermission;
				const method='POST';
				let params={
					meeting_id:this.itemContent.id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0 && res.data.permission==1){
						this.$router.push({
						path:'/meeting/details',
						query:{
							meeting_id:this.itemContent.id
						}
					})
					}
					if(res.code==0 && res.data.permission==0){
						this.$router.push({
						path:'/meeting/password',
						query:{
							meeting_id:this.itemContent.id,
							img_src:this.itemContent.banner
						}
					})
					}
				})
			},
			//输入密码 正确跳转 错误提示错误信息
			// meetingPassword(){
			// 	const url=MeetingPassword;
			// 	const method='POST';
			// 	let params={
			// 		meeting_id:this.itemContent.id,
			// 		watch_password:this.password
			// 	}
			// 	fetch(url,params,method)
			// 	.then((res)=>{
			// 		if(res.code==0){
			// 			this.$router.push({
			// 			path:'/meeting/details',
			// 			query:{
			// 				meeting_id:this.itemContent.id
			// 			}
			// 		})
			// 		}
			// 		else{
			// 				this.$toast.fail({
          	// 					message:res.error_msg,
          	// 					position:'top'
        	// 				});
			// 		}
			// 	})
			// 	this.password='';
			// },
			//收藏文章
			collectArticle(){
				const url=ArticlesCollect;
				let params={
					article_id:this.itemContent.id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.itemContent.isCollect=res.data.attach;
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.popup_title{
			font-size: 15px;
			margin-top: 20px;
		}
	.buttonGroup{
			display: flex;
			justify-content: space-around;
			.button{
				height: 20px;
				margin: 10px auto;
			}
	}
	.item-block{
		
		padding:14px 0;
		@include flex(row);
		align-items:center;
		justify-content:space-between;
	    border-bottom:1px solid #bfbfbf;
		.cover{
			position:relative;
			width:105px;
			height:60px;
			img{
				width:100%;
				height:100%;
				position:absolute;
				left:50%;
				top:50%;
				transform: translate(-50%,-50%);

			}
		}
		.details{
			margin-left:10px;
			flex:1;
			@include flex(column);
			justify-content:space-between;
			height:75px;
			p{
				text-align: justify;
				font-size:14px;
				color:$color-black;
				letter-spacing: 0.4px;
				line-height: 20px;
			}
			.bottom,.hasWriter{
				
				justify-content:space-between;
				.left{
					font-size: 13px;
					color: $color-black;
					letter-spacing: 0.46px;
					width:2.5rem;
				}
				.right{
					font-size:12px;
					color:$color-gray;
					letter-spacing: 0.39px;
					.van-icon{
						font-size:14px;
						display:inline-block;
						vertical-align:-2px;
						color:$color-black;
						margin-right:5px;
					}
					.van-icon-star{
						color:#FBBD5C;
					}
				}
				.guide-name{
					font-size: 12px;
					line-height: 20px;
					color: rgb(105, 105, 105);
					letter-spacing: 0.46px;
				}
			}
			.bottom{
				@include flex(row);
			}
			.hasWriter{
				// margin-top:10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/ItemBlock.vue